import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { ActivityTimeBuilder } from './activity-time.builder';
import { WorkingHoursValidation } from '../working-hours-validation';
import { RoleBuilder } from './role.builder';
import { WorkingShiftBuilder } from './working-shift.builder';
import { sortWorkingHours } from '../../utils/working-hour.utils';
import { mapCollection } from '../../utils/collection.utils';

export class WorkingHoursValidationBuilder {
  static fromJson(json) {
    return (json)
      ? new WorkingHoursValidation(
        json.hash,
        json.userHash,
        json.userName,
        json.userReference,
        json.userWorkingShiftHash,
        parseNumber(json.validationDay),
        json.validated,
        json.hasIncompleteData,
        json.shortDay,
        ActivityTimeBuilder.fromList(json.activitiesTime),
        parseNumber(json.totalTime),
        RoleBuilder.fromList(json.roles),
        WorkingShiftBuilder.fromJson(json.workingShift)
      )
      : null;
  }

  static fromList(list) {
    return isArray(list) ? sortWorkingHours(mapCollection(WorkingHoursValidationBuilder.fromJson, list)) : [];

  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/working-hours-validation.builder.ts